import React, { memo, FC } from 'react';

type PropsT = {
  width?: string;
  height?: string;
  fill?: string;
};

const CloseIcon: FC<PropsT> = ({ width, height, fill}) => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M19.706 3.4043C19.9117 3.19857 20.2454 3.19857 20.4511 3.4043L20.5957 3.54883C20.8012 3.75458 20.8013 4.08829 20.5957 4.29395L13.0664 11.8232C13.0195 11.8701 12.9931 11.9337 12.9931 12C12.9931 12.0663 13.0195 12.1299 13.0664 12.1768L20.5957 19.7061C20.8025 19.913 20.8002 20.2465 20.5947 20.4453C20.5264 20.5113 20.4892 20.5471 20.4677 20.5664C20.2266 20.783 19.8925 20.7822 19.6914 20.5811L12.1767 13.0664C12.0791 12.9688 11.9208 12.9688 11.8232 13.0664L4.29389 20.5957C4.08693 20.8027 3.75344 20.8003 3.55464 20.5947C3.48856 20.5264 3.4529 20.4893 3.43354 20.4678C3.21686 20.2266 3.21774 19.8926 3.41889 19.6914L10.9335 12.1768C10.9804 12.1299 11.0068 12.0663 11.0068 12C11.0068 11.9337 10.9804 11.8701 10.9335 11.8232L3.40424 4.29395C3.19855 4.08825 3.19862 3.75457 3.40424 3.54883L3.54878 3.4043C3.75451 3.19867 4.0882 3.1986 4.29389 3.4043L11.8232 10.9336C11.8701 10.9805 11.9336 11.0068 11.9999 11.0068C12.0662 11.0068 12.1299 10.9804 12.1767 10.9336L19.706 3.4043Z" fill="#909090"/>
</svg>
  );
};

export default memo(CloseIcon);import React, { memo, FC } from 'react';

type PropsT = {
  width?: string;
  height?: string;
  fill?: string;
};

const CloseIcon: FC<PropsT> = ({ width, height, fill}) => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M19.706 3.4043C19.9117 3.19857 20.2454 3.19857 20.4511 3.4043L20.5957 3.54883C20.8012 3.75458 20.8013 4.08829 20.5957 4.29395L13.0664 11.8232C13.0195 11.8701 12.9931 11.9337 12.9931 12C12.9931 12.0663 13.0195 12.1299 13.0664 12.1768L20.5957 19.7061C20.8025 19.913 20.8002 20.2465 20.5947 20.4453C20.5264 20.5113 20.4892 20.5471 20.4677 20.5664C20.2266 20.783 19.8925 20.7822 19.6914 20.5811L12.1767 13.0664C12.0791 12.9688 11.9208 12.9688 11.8232 13.0664L4.29389 20.5957C4.08693 20.8027 3.75344 20.8003 3.55464 20.5947C3.48856 20.5264 3.4529 20.4893 3.43354 20.4678C3.21686 20.2266 3.21774 19.8926 3.41889 19.6914L10.9335 12.1768C10.9804 12.1299 11.0068 12.0663 11.0068 12C11.0068 11.9337 10.9804 11.8701 10.9335 11.8232L3.40424 4.29395C3.19855 4.08825 3.19862 3.75457 3.40424 3.54883L3.54878 3.4043C3.75451 3.19867 4.0882 3.1986 4.29389 3.4043L11.8232 10.9336C11.8701 10.9805 11.9336 11.0068 11.9999 11.0068C12.0662 11.0068 12.1299 10.9804 12.1767 10.9336L19.706 3.4043Z" fill="#909090"/>
</svg>
  );
};

export default memo(CloseIcon);